import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const showcaseCategories = categories.filter((c) =>
  ['dianying', 'dianshiju', 'dongman', 'zongyi', 'jilupian', 'dongzuo'].includes(c.slug)
);

export default function CategoryShowcase() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-900/50">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {showcaseCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-200/40 hover:bg-background-200/60 border border-background-200/20 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-400 group-hover:text-primary-300`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-200 group-hover:text-foreground-50 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}